import Request from './../../request';

// import props
import { IDocumentProps, IFileProps } from '../../../props/general';

const VesselDocumentService = {
  retrieve: async (id: string): Promise<IDocumentProps[]> => {
    try {
      const results = await Request.get(`/api/vessels/${id}/documents`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  new: async (vesselId: string, data: FormData): Promise<IDocumentProps> => {
    try {
      const result = await Request.post(`/api/vessels/${vesselId}/documents`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  delete: async (vesselId: string, data: FormData): Promise<void> => {
    try {
      await Request.post(`/api/vessels/${vesselId}/documents/delete`);
      return;
    } catch (e) {
      throw e;
    }
  },
};

export default VesselDocumentService;
